import { useFeatureFlag } from '@fs/zion-flags'
import { US_CENSUS_CMS_COLLECTION_IDS } from './collectionConstants'

export default function useCmsCollectionGating() {
  const cmsCollectionsFlag = useFeatureFlag('search_cmsCollections')
  const cmsHrFlag = useFeatureFlag('search_cmsCollectionsHr')

  // Whether to render the CMS route for a given collection (used for routing in App.js)
  const isCmsEnabledForId = () => cmsCollectionsFlag?.isOn || cmsHrFlag?.isOn

  // Whether to embed the wiki about section (census always excluded)
  const shouldEmbedWikiAbout = (id) =>
    (cmsCollectionsFlag?.isOn || cmsHrFlag?.isOn) && !US_CENSUS_CMS_COLLECTION_IDS.has(id)

  return { cmsCollectionsFlag, isCmsEnabledForId, shouldEmbedWikiAbout }
}
